import styled from 'styled-components';
import { Input } from '../../../components/input';
import { COLORS } from '../../../consts/colors';

export const CustomInput = styled(Input)`
  margin-bottom: 12px;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const SelectLabel = styled.label`
  font-weight: 400;
  margin-bottom: 4px;
`;

export const CustomSelect = styled.select`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px;
  border: 1px solid ${COLORS.DARK_GRAY};
  background-color: ${COLORS.WHITE};
  color: ${COLORS.DARKER_GRAY};
`;

export const CheckboxRow = styled.div`
  margin: 10px 0 15px 0;
`;

export const OptionalToggle = styled.button`
  background: none;
  border: none;
  color: ${COLORS.LIGHT_BLUE};
  cursor: pointer;
  padding: 6px 0;
  font-size: 14px;
  text-align: right;
  margin-bottom: 10px;
  text-decoration: underline;
  font-family: inherit;

  &:hover {
    color: ${COLORS.DARK_BLUE};
  }
`;

export const OptionalFieldsContainer = styled.div`
  background-color: ${COLORS.EXTRA_LIGHT_GRAY};
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 15px;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 25px;
`;

export const ErrorMessage = styled.div`
  color: ${COLORS.LIGHT_RED};
  font-weight: bold;
  text-align: center;
  margin-top: 15px;
`;
